module.exports = __webpack_public_path__ + "static/media/tissueSclerenchymaFiberSclereid.81ea19bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tissueSclerenchymaFiberSclereid.jpg
// module id = 364
// module chunks = 0